import { createFileRoute } from '@tanstack/react-router'
import { OpportunityManagementContextProvider } from "@/opportunity/OpportunityManagementContext";
import OpportunityManagementViewer from "@/opportunity/OpportunityManagementViewer";

export const Route = createFileRoute(
  '/_authenticated/_staff/issue-management',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <OpportunityManagementContextProvider>
      <OpportunityManagementViewer/>
    </OpportunityManagementContextProvider>
  )
}
